import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from 'primereact/inputnumber';

const TarifasTable = ({
  tarifas,
  filters,
  loading,
  selectedTarifa,
  displayDialog,
  newTarifa,
  setNewTarifa,
  handleCloseDialog,
  templateButton,
  handleUpdateTarifa,
  guardando,
  nombreEmpresa,
}) => {
  return (
    <div>
      {/* ---------------------------------------- */}
      {/* TABLA PRODUCTOS */}
      {/* ---------------------------------------- */}
      <div className="card col-12 md:col-12">
        <DataTable
          header={`Tarifas de Productos: ${nombreEmpresa}`}
          value={tarifas.tarifasTipoProductos}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50, 100]}
          dataKey="id"
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          stripedRows
          showGridlines
          emptyMessage="No hay tarifas para mostrar"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} tarifas"
          className="p-datatable-gridlines"
          tableStyle={{ minWidth: "50rem" }}
          scrollHeight="57vh"
          scrollable
          reorderableColumns
          resizableColumns
          columnResizeMode="fit"
        >
          <Column
            field="descripcion"
            header="Tipo Producto"
            sortable
            filter
            filterPlaceholder="Buscar por tipo"
            style={{ minWidth: "12rem" }}
          />
          <Column
            field="tarifa_base"
            header="Tarifa Base"
            sortable
            style={{ minWidth: "10rem" }}
            body={(rowData) => (
              <span>{rowData.tarifa_base.toLocaleString("es-CL")}</span>
            )}
          />
          <Column
            field="moneda"
            header="Moneda"
            sortable
            filter
            filterPlaceholder="Buscar por moneda"
            style={{ minWidth: "8rem" }}
          />
          <Column
            header="Acción"
            body={(rowData) => templateButton({ ...rowData, tipo: "producto" })}
            style={{ minWidth: "8rem" }}
            
          />
        </DataTable>
      </div>
      {/* ---------------------------------------- */}
      {/* TABLA SUBPRODUCTOS */}
      {/* ---------------------------------------- */}
      <div className="card col-12 md:col-12">
        <DataTable
          header={`Tarifas de Subproductos: ${nombreEmpresa}`}
          value={tarifas.tarifasTipoSubProductos}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50, 100]}
          dataKey="id"
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          stripedRows
          showGridlines
          emptyMessage="No hay tarifas para mostrar"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} tarifas"
          className="p-datatable-gridlines"
          tableStyle={{ minWidth: "50rem" }}
          scrollHeight="57vh"
          scrollable
          reorderableColumns
          resizableColumns
          columnResizeMode="fit"
        >
          <Column
            field="descripcion"
            header="Tipo Subproducto"
            sortable
            filter
            filterPlaceholder="Buscar por tipo"
            style={{ minWidth: "12rem" }}
          />
          <Column
            field="tarifa_base"
            header="Tarifa Base"
            sortable
            style={{ minWidth: "10rem" }}
            body={(rowData) => (
              <span>{rowData.tarifa_base.toLocaleString("es-CL")}</span>
            )}
          />
          <Column
            field="moneda"
            header="Moneda"
            sortable
            filter
            filterPlaceholder="Buscar por moneda"
            style={{ minWidth: "8rem" }}
          />
          <Column
            header="Acción"
            body={(rowData) => templateButton({ ...rowData, tipo: "subproducto" })}
            style={{ minWidth: "8rem" }}
          />
        </DataTable>
      </div>
      {/* ---------------------------------------- */}
      {/* TABLA SERVICIOS */}
      {/* ---------------------------------------- */}
      {/*<div className="card col-12 md:col-12">
        <DataTable
          header="Tarifas Servicios"
          value={tarifas.tarifasTipoServicios}
          paginator
          rows={10}
          dataKey="id"
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          stripedRows
          showGridlines
          emptyMessage="No hay tarifas para mostrar"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} tarifas"
          className="p-datatable-gridlines"
          tableStyle={{ minWidth: "50rem" }}
        >
          <Column
            field="descripcion"
            header="Tipo Servicio"
            sortable
            filter
            filterPlaceholder="Buscar por tipo"
            style={{ minWidth: "12rem" }}
          />
          <Column
            field="tarifa_base"
            header="Tarifa Base"
            sortable
            style={{ minWidth: "10rem" }}
            body={(rowData) => (
              <span>{rowData.tarifa_base.toLocaleString("es-CL")}</span>
            )}
          />
          <Column
            field="moneda"
            header="Moneda"
            sortable
            filter
            filterPlaceholder="Buscar por moneda"
            style={{ minWidth: "8rem" }}
          />
          <Column
            header="Acción"
            body={(rowData) => templateButton({ ...rowData, tipo: "servicio" })}
            style={{ minWidth: "8rem" }}
          />
        </DataTable>
      </div>*/}

      <Dialog
        blockScroll
        header="Detalles de Tarifa"
        visible={displayDialog}
        onHide={handleCloseDialog}
        className="p-fluid product-dialog"
        modal
        footer={
          <>

            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-outlined p-button-rounded p-button mr-2 mb-2 mt-2"
              onClick={handleCloseDialog}
            />

            <Button
              label="Confirmar"
              icon={guardando ? "pi pi-spin pi-spinner" : "pi pi-save"}
              className="p-button-success p-button-rounded p-button mr-2 mb-2 mt-2"
              onClick={() => {
                // Validar antes de llamar handleUpdateTarifa
                if (!newTarifa || newTarifa <= 0) {
                  alert("La tarifa debe ser mayor a 0");
                  return;
                }
                handleUpdateTarifa();
              }}
              disabled={loading || guardando}
            />
          </>
        }
      >
        {selectedTarifa && (
          <div className="card p-fluid formgrid grid">
            <div className="field col-12 md:col-12">
              <DataTable
                value={[selectedTarifa]}
                className="p-datatable-gridlines"
                showGridlines
                stripedRows
              >
                <Column field="descripcion" header="Descripcion" />
                <Column
                  field="tarifa_base"
                  header="Tarifa Actual"
                  body={(rowData) => (
                    <span>{rowData.tarifa_base.toLocaleString("es-CL")}</span>
                  )}
                />
                <Column field="moneda" header="moneda" />
              </DataTable>
            </div>
            <div className="field col-12 md:col-12">

              <h6>Ingrese la nueva tarifa</h6>
              
              <InputNumber
                id="newTarifa"
                value={newTarifa}
                onValueChange={(e) => {
                  if (e.value <= 0) {
                    return;
                  }
                  setNewTarifa(e.value);
                }}
                placeholder="Ingrese Monto"
                min={0}
                max={1000}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={2}
                locale="es-CL"
              />
            </div>

            
          </div>
        )}
      </Dialog>
    </div>
  );
};

export default TarifasTable;
